import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { PasswordParams } from '../../models/password-params';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-partner-password',
  templateUrl: './partner-password.component.html',
  styleUrls: ['./partner-password.component.css']
})
export class PartnerPasswordComponent implements OnInit {

  @Input()
  showOldPasswordConfirmation: boolean;

  @Input()
  easyMode: boolean;

  @Input()
  password: PasswordParams;

  @ViewChild(NgForm, {static: true}) form;

  @Output() eventFormValid = new EventEmitter();
  @Output() eventFormInvalid = new EventEmitter();

  @Output() eventFormDirty = new EventEmitter();
  @Output() eventFormNotDirty = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this._validate(this.password.oldPassword, this.password.password, this.password.repeatPassword);
    this.form.valueChanges.subscribe(
      data => {
        this._validate(data.oldPassword, data.password, data.repeatPassword);
      });
  }

  _validate(oldPassword, password, repeatPassword) {
    if (this.showOldPasswordConfirmation && !oldPassword && !password && !repeatPassword) {
      this.eventFormInvalid.emit(this.form);
      this.eventFormNotDirty.emit(this.form);
    } else {
      this.emitValidDirtyEvents();
    }
  }

  emitValidDirtyEvents() {
    if (this.form.valid) {
      this.eventFormValid.emit(this.form);
    } else {
      this.eventFormInvalid.emit(this.form);
    }
    if (this.form.dirty) {
      this.eventFormDirty.emit(this.form);
    } else {
      this.eventFormNotDirty.emit(this.form);
    }
  }
}


